import React, { useEffect, useState } from "react";
import aluminicomitemember from '../assets/images/aluminiecomiteeimg.webp';
import AOS from "aos";
import 'aos/dist/aos.css';
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import Spinner from "react-activity/dist/Spinner";
import { Link } from "react-router-dom";

const Alumnicommitee = () => {
    const [showloading, setshowloding] = useState(false);
    const [fetcheddata, setfetcheddata] = useState([]);

    const fetchcommiteedata = async() => {
        setshowloding(true);
        const headers = {
            headers: {
              "Content-Type": "application/json",
            },
          };
          let resp = await axios
          .get(apiUrl + "getusercommitteemembers", headers)
          .then((res) => {
            if (res.data.status == "success" && res?.data?.data?.length > 0) {
                setfetcheddata(res?.data?.data)
                setshowloding(false);
            } else {
                setfetcheddata([])
                setshowloding(false);
            }
          })
          setshowloding(false);

    }

    useEffect(() => {
            AOS.init();
            AOS.refresh();
            fetchcommiteedata();
        }, [])
    return (
        <div>
            <section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">Alumni Commitee</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                        about Alumni Commitee</p>
                </div>
            </section>
            <section className="alumini-comitee-member-sec">
                <div className="container">
                    <div className="row">

                        {
                            fetcheddata?.length > 0 ?
                            fetcheddata?.map((item, index) => {
                                return (
                                    <div className="col-12 col-md-6 col-lg-3 mb-2 mb-md-4" key={index} data-aos="fade-up" data-aos-delay="300" data-aos-duration="300">
                            <div className="app-container" >
                                <div className="hover-image-container">
                                    <img src={assetsUrl+'alumnimembers/'+item?.image} alt="Member" className="hover-image" />
                                    <div className="social-overlay">
                                        {
                                            item?.facebook ?
                                            <Link to={item?.facebook} target="_blank">
                                                <i class="fa fa-facebook    alumnini-icon-social" aria-hidden="true"></i>
                                            </Link> : null
                                        }
                                        {
                                            item?.twitter ?
                                            <Link to={item?.twitter} target="_blank">
                                                <i class="fa fa-twitter    alumnini-icon-social" aria-hidden="true"></i>
                                            </Link> : null
                                        }
                                        {
                                            item?.linkedin ?
                                            <Link to={item?.linkedin} target="_blank">
                                                <i class="fa fa-linkedin    alumnini-icon-social" aria-hidden="true"></i>
                                            </Link> : null
                                        }
                                        {
                                            item?.instagram ?
                                            <Link to={item?.instagram} target="_blank">
                                                <i class="fa fa-instagram    alumnini-icon-social" aria-hidden="true"></i>
                                            </Link> : null
                                        }
                                        {
                                            item?.pinterest ?
                                            <Link to={item?.pinterest} target="_blank">
                                                <i class="fa fa-pinterest-p    alumnini-icon-social" aria-hidden="true"></i>
                                            </Link> : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <p className="alumini-comitee-member-name">{item?.name}</p>
                        </div>
                                )
                            }) :
                            showloading ?
                            <div>
                                 <Spinner color='#264790' size={22} className='spinnerCenter' />
                            </div>
                            :
                            <p className="alumini-comitee-member-name" style={{textAlign: 'center'}}>Commitee member not added yet</p>
                        }

                        

                        
                       
                       
                    </div>
                </div>
            </section>
        </div>
    )
}
export default Alumnicommitee